import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { getDeliveryPricing, updateDeliveryPricing } from "../../api/adminService";
import { formatCurrency } from "./constants";

export default function DeliveryPricing() {
  const [rows, setRows] = useState([]);
  const [edits, setEdits] = useState({});
  const [error, setError] = useState("");
  const [savingId, setSavingId] = useState(null);

  useEffect(() => {
    getDeliveryPricing()
      .then(setRows)
      .catch(() => setError("Could not load delivery pricing. Is the API running?"));
  }, []);

  function handleChange(id, value) {
    setEdits((prev) => ({ ...prev, [id]: value }));
  }

  async function handleSave(id) {
    const value = edits[id];
    if (value === undefined) return;
    setSavingId(id);
    try {
      const updated = await updateDeliveryPricing(id, Number(value));
      setRows((prev) => prev.map((r) => (r.deliveryDistrictPriceId === id ? updated : r)));
      setEdits((prev) => {
        const next = { ...prev };
        delete next[id];
        return next;
      });
    } catch {
      setError("Could not save this price.");
    } finally {
      setSavingId(null);
    }
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Delivery Pricing
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box sx={{ bgcolor: "background.paper", borderRadius: 2, overflow: "hidden" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Country</TableCell>
              <TableCell>District</TableCell>
              <TableCell align="right">Current Price</TableCell>
              <TableCell align="right" width={200}>
                New Price
              </TableCell>
              <TableCell align="center" width={80}>
                Save
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.deliveryDistrictPriceId} hover>
                <TableCell>{row.country}</TableCell>
                <TableCell>{row.districtName}</TableCell>
                <TableCell align="right">{formatCurrency(row.price)}</TableCell>
                <TableCell align="right">
                  <TextField
                    size="small"
                    type="number"
                    value={edits[row.deliveryDistrictPriceId] ?? ""}
                    placeholder={String(row.price)}
                    onChange={(e) => handleChange(row.deliveryDistrictPriceId, e.target.value)}
                    sx={{ width: 140 }}
                  />
                </TableCell>
                <TableCell align="center">
                  <IconButton
                    color="primary"
                    disabled={edits[row.deliveryDistrictPriceId] === undefined || savingId === row.deliveryDistrictPriceId}
                    onClick={() => handleSave(row.deliveryDistrictPriceId)}
                  >
                    <SaveIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}
